import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { prefetchRoute } from "../../routePrefetch";

const NAV_ITEMS = [
  { label: "Home", path: "/" },
  { label: "Products", path: "/products" },
  { label: "Pricing", path: "/pricing" },
  { label: "About Us", path: "/about-us" },
  { label: "Blog", href: "https://blog.deepaarogya.com/" },
  { label: "Contact Us", path: "/contact-us" },
];

export default function NavDaa() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return;
    NAV_ITEMS.forEach((item) => {
      if (item.path) prefetchRoute(item.path);
    });
    prefetchRoute("/demo");
  }, [menuOpen]);

  const onNavIntent = (path) => {
    if (path) prefetchRoute(path);
  };

  return (
    <nav className={`nav ${scrolled ? "scrolled" : ""} ${menuOpen ? "nav--open" : ""}`} aria-label="Primary">
      <Link to="/" className="brand brand-with-logo" onClick={() => window.scrollTo({ top: 0 })}>
        <BrandLogo variant="nav" priority />
        <span className="brand-text">Deepaarogya AI</span>
      </Link>

      <ul className="navlinks">
        {NAV_ITEMS.map((item) =>
          item.href ? (
            <li key={item.label}>
              <a href={item.href} target="_blank" rel="noopener noreferrer">
                {item.label}
              </a>
            </li>
          ) : (
            <li key={item.label}>
              <Link
                to={item.path}
                className={location.pathname === item.path ? "nav-active" : undefined}
                onMouseEnter={() => onNavIntent(item.path)}
                onFocus={() => onNavIntent(item.path)}
                onTouchStart={() => onNavIntent(item.path)}
              >
                {item.label}
              </Link>
            </li>
          )
        )}
      </ul>

      <Link to="/demo" className="nav-cta">
        Schedule a Demo
      </Link>

      <button
        type="button"
        className="nav-menu-btn"
        aria-expanded={menuOpen}
        aria-controls="mobile-menu"
        aria-label="Toggle menu"
        onClick={() => setMenuOpen((v) => !v)}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      {menuOpen && (
        <>
          <button
            type="button"
            className="nav-mobile-backdrop"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          />
          <div id="mobile-menu" className="nav-mobile-menu">
          {NAV_ITEMS.map((item) =>
            item.href ? (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.label}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                onTouchStart={() => onNavIntent(item.path)}
              >
                {item.label}
              </Link>
            )
          )}
          <Link to="/demo" className="btn-primary nav-mobile-cta" onClick={() => setMenuOpen(false)}>
            Schedule a Demo
          </Link>
          </div>
        </>
      )}
    </nav>
  );
}
